var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"systemYbCourse_line",attrs:{"id":"systemYbCourse_line"}})
}
var staticRenderFns = []

export { render, staticRenderFns }